import { i18n } from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import workflowListActions from 'src/modules/workflow/list/workflowListActions';
import WorkflowService from 'src/modules/workflow/workflowService';
import Message from 'src/view/shared/message';

const prefix = 'WORKFLOW_FORM';

const workflowFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await WorkflowService.find(id);
      }

      dispatch({
        type: workflowFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: workflowFormActions.INIT_ERROR,
      });

      getHistory().push('/workflow');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: workflowFormActions.CREATE_STARTED,
      });

      await WorkflowService.create(values);

      dispatch({
        type: workflowFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.workflow.create.success'),
      );

      getHistory().push('/workflow');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: workflowFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: workflowFormActions.UPDATE_STARTED,
      });

      await WorkflowService.update(id, values);

      dispatch({
        type: workflowFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.workflow.update.success'),
      );

      getHistory().push('/workflow');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: workflowFormActions.UPDATE_ERROR,
      });
    }
  },

  // Duplicate a workflow and refresh list without redirect
  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: workflowFormActions.CREATE_STARTED,
      });

      await WorkflowService.create(values);

      dispatch({
        type: workflowFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.workflow.create.success'),
      );

      // Refresh current workflow list without navigating
      dispatch(workflowListActions.doFetchCurrentFilter());
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowFormActions.CREATE_ERROR,
      });
    }
  },
};

export default workflowFormActions;
